import Component from "@ember/component";
import highlightSearch from "discourse/lib/highlight-search";
import { observes, on } from "discourse-common/utils/decorators";
export default Component.extend(dt7948.p({
  tagName: "span",
  _highlightOnInsert() {
    const term = this.highlight;
    highlightSearch(this.element, term);
  }
}, [["method", "_highlightOnInsert", [observes("highlight"), on("didInsertElement")]]]));